<div #container
     class="container">

  <app-header main="true"
              [greeting]="greeting"
              (clickGreeting)="onClickGreeting()"
              placeholder="이 곳의 내용, 무엇이든 검색!"
              [keyHistory]="HISTORY_KEY_SEARCH_TOTAL"
              (search)="goSearch($event)"></app-header>

  <app-left-menu></app-left-menu>


  <section class="main-menu-list">

    <div class="wrap inner main-menu-grid">

      <a class="main-menu-card main-menu-word"
         aria-label="단어와 예문"
         (click)="onClickWord($event)">
        <span class="main-menu-text" big>단어와<br>예문</span>
      </a>

      <a class="main-menu-card main-menu-homonym"
         aria-label="같은 글자, 다른 소리"
         (click)="onClickHomonym($event)">
        <span class="main-menu-text">같은 글자,<br>다른 소리</span>
      </a>

      <a class="main-menu-card main-menu-saseung"
         aria-label="사 성 옥편"
         (click)="onClickSaseung($event)">
        <span class="main-menu-text">
          사 성 옥편
          <span class="main-menu-hanja">四聲玉篇</span>
        </span>
      </a>

      <a class="main-menu-card main-menu-example"
         aria-label="문장 듣기"
         (click)="onClickExample($event)">
        <span class="main-menu-text" big>문장 듣기</span>
      </a>

      <a class="main-menu-card main-menu-sajaseungeo"
         aria-label="사 자 성어"
         (click)="onClickSajaseungeo($event)">
        <span class="main-menu-text">
          사 자 성어
          <span class="main-menu-hanja">四字成語</span>
        </span>
      </a>

      <a class="main-menu-card main-menu-dialect"
         aria-label="모두 우리말"
         (click)="onClickDialect($event)">
        <span class="main-menu-text" big>모두<br>우리말</span>
      </a>

      <a class="main-menu-card main-menu-proverb"
         aria-label="속담"
         (click)="onClickProverb($event)">
        <span class="main-menu-text">속담</span>
      </a>
    </div>


  </section>


  <section class="main-video"
           *ngIf="listVideo && listVideo.length > 0">

    <div class="inner wrap">

      <div class="video-list-tit">새로 등록된 동영상</div>

      <div class="video-list-wrap">

        <ul>
          <li *ngFor="let video of listVideo; let idx = index">
            <app-video-box-main [video]="video"
                                [sendingBookmark]="sendingBookmark"
                                (toggleBookmark)="ToggleBookmark($event)"></app-video-box-main>
          </li>

        </ul>
      </div>

    </div>


  </section>

  <app-footer [on]="FooterOn.HOME"></app-footer>


</div>

<app-common-popups></app-common-popups>
